import { z } from 'zod'

export const createNotificationTemplateSchema = z.object({
  name: z.string().min(1, 'Template name is required').max(255),
  type: z.string().default('EMAIL'),
  subject: z.string().min(1, 'Subject is required').max(500),
  bodyHtml: z.string().min(1, 'HTML body is required'),
  bodyText: z.string().min(1, 'Text body is required'),
  variables: z.array(z.string()).default([]),
  description: z.string().optional()
})

export const updateNotificationTemplateSchema = z.object({
  subject: z.string().min(1).max(500).optional(),
  bodyHtml: z.string().min(1).optional(),
  bodyText: z.string().min(1).optional(),
  variables: z.array(z.string()).optional(),
  description: z.string().optional()
})

export const templatePreviewSchema = z.object({
  subject: z.string(),
  bodyHtml: z.string(),
  bodyText: z.string(),
  variables: z.record(z.string(), z.any())
})

export type CreateNotificationTemplateData = z.infer<typeof createNotificationTemplateSchema>
export type UpdateNotificationTemplateData = z.infer<typeof updateNotificationTemplateSchema>
export type TemplatePreviewData = z.infer<typeof templatePreviewSchema>
